var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.491,
    height: 54.491,
    viewBox: "0 0 54.491 54.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.309,
    y1: 0.5,
    x2: 1.057,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#c872fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#9428e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#b64eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#cc83ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffefa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.309,
    y1: 0.077,
    x2: 1.304,
    y2: 1.141,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#e3d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#bca0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906fe0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_35884",
    x: 11.166,
    y: 11.165,
    width: 38.16,
    height: 38.16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2f0071",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.888,
    cy: 0.083,
    r: 1.901,
    gradientTransform: "translate(0 0.033) scale(1 0.603)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#d045e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#7c22e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d08a8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12471",
    "data-name": "Group 12471",
    transform: "translate(-14.907 -436.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19312",
    "data-name": "Path 19312",
    d: "M18.515,0A18.515,18.515,0,1,1,0,18.515,18.515,18.515,0,0,1,18.515,0Z",
    transform: "translate(42.152 489.685) rotate(-135)",
    stroke: "rgba(200,124,255,0.69)",
    strokeWidth: 1.5,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35808",
    "data-name": "Group 35808",
    transform: "translate(-0.939 0.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(33.512 453.34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -17.67, -17.67)",
    filter: "url(#Path_35884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35884-2",
    "data-name": "Path 35884",
    d: "M9.431,0a9.587,9.587,0,0,1,9.5,11.651,17.376,17.376,0,0,0-.433,3.741v2.435a.675.675,0,0,1-.675.675H15.393a17.374,17.374,0,0,0-3.741.433A9.581,9.581,0,1,1,9.431,0Z",
    transform: "translate(17.67 17.67)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_35882",
    "data-name": "Path 35882",
    d: "M214.274,274.451a.94.94,0,1,0,.94.94.94.94,0,0,0-.94-.94",
    transform: "translate(-171.182 192.22)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35883",
    "data-name": "Path 35883",
    d: "M171.607,64.876a.94.94,0,0,0,.94-.94.94.94,0,1,1,1.5.759,3.438,3.438,0,0,0-1.5,2.753v1.187a.94.94,0,1,0,1.88,0V67.449a1.611,1.611,0,0,1,.726-1.238,2.819,2.819,0,1,0-4.486-2.274.94.94,0,0,0,.94.94",
    transform: "translate(-130.395 396.172)",
    fill: "url(#radial-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralHelpIcon);
export default __webpack_public_path__ + "static/media/general-help-icon.0f75fcf2beaecee2734558c4e2eff6f8.svg";
export { ForwardRef as ReactComponent };